import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _FolderDelLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", d: "m17 21 5-5m0 5-5-5M19.5 14v-1.5c0-1.886 0-2.828-.586-3.414S17.386 8.5 15.5 8.5h-1.343c-.818 0-1.226 0-1.594-.152s-.657-.442-1.235-1.02l-.656-.656c-.578-.578-.868-.868-1.235-1.02S8.66 5.5 7.843 5.5H7.5c-1.886 0-2.828 0-3.414.586S3.5 7.614 3.5 9.5v5c0 1.886 0 2.828.586 3.414s1.528.586 3.414.586H15" })));
}
const FolderDelLight = forwardRef(_FolderDelLight);
export { FolderDelLight };
